import React, { FC } from 'react';
import { IYoutubeModalProps } from "./models";
import './style.scss';

const YoutubeModal: FC<IYoutubeModalProps> = (props) => {
    return (
        <div id="videoModal" className="YTVideomodal">
            <div className="modal-container" onClick={() => props.setModalOpen(false)}>
                <div className="modal-content">
                    <button onClick={() => props.setModalOpen(false)} className="close-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"></path></svg></button>
                    <div className="video-container">
                        <iframe id="youtubeIframe"
                            name=''
                            src={props?.resourceUrl}
                            frameBorder={0}
                            allow="autoplay; fullscreen"
                            scrolling='no'
                            allowFullScreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default YoutubeModal;